module.exports = __webpack_public_path__ + "static/img/RAC188M_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAC188M_1.png
// module id = IqcB
// module chunks = 0